import { render, staticRenderFns } from "./ReleaseNotesListModal.vue?vue&type=template&id=c1bba3ae&scoped=true"
import script from "./ReleaseNotesListModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bba3ae",
  null
  
)

export default component.exports